import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TakeawayServices } from '../../services';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../../orders/services';
import { TakeawayOrderUpDelPage } from '../../takeaway-order-updel/takeaway-order-updel';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-list',
  templateUrl: 'takeaway-order-list.html',
})
export class TakeawayOrderListPage {
  orders: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices) {
    //getIndexByTableuid
    this.takeawayServices.getIndexByTableuid();
    //getOrders
    this.ordersCoServices.getOrders(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);

    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(takeawayServices.tables_array[takeawayServices.selected_table_tpv_index].ticket.list));

  }

  deleteTableList(valueSearch) {
    this.takeawayServices.deleteTableList(valueSearch);
  }

  async ionViewWillEnter() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //listSelectedTicket
    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
  }

  async deleteTip() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //tip
    this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.tip = 0;
    var uid = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID;
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //update tables
    this.takeawayServices.afs.collection('tables').doc(uid).update({
      ticket: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket
    });
  }

  openMod() {
    this.navCtrl.push(TakeawayOrderUpDelPage, {
      update: true
    });
  }
  
  openDelete() {
    this.navCtrl.push(TakeawayOrderUpDelPage, {
      update: false
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-list/takeaway-order-list.ts